import {Component, HostListener, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder} from "@angular/forms";
import {EventItem, Lookups, Race, RaceCommercialItem, ScoringForType, Waypoint, WaypointType} from "@model";
import {AbstractComponent} from "../abstract.component";
import {TranslocoService} from "@ngneat/transloco";
import {environment} from "@environment";

@Component({
  selector: 'race-details-modal',
  templateUrl: './race-details-modal.component.html',
  styleUrls: ['./race-details-modal.component.scss']
})
export class RaceDetailsModalComponent extends AbstractComponent implements OnInit {
  @Input() race?: Race;
  @Input() eventItem?: EventItem;
  @Input() title?: string;
  @Input() confirmButtonTitle?: string;
  @Input() dismissButtonTitle?: string;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() waypointList: Waypoint[] = [];
  @Input() countries: Lookups[] = [];
  @Input() raceCommercialItems: RaceCommercialItem[] | undefined;
  @Input() currencyLabel?: string;

  startWaypoint?: Waypoint;
  finishWaypoint?: Waypoint;
  controlPointsList: Waypoint[] = [];

  lat: number = environment.headquartersLat;
  lng: number = environment.headquartersLng;

  isXxlScreen: boolean = false;

  constructor(public activeModal: NgbActiveModal, public formBuilder: FormBuilder, public translocoService: TranslocoService,) {
    super();
    this.checkScreenSize();

  }

  ngOnInit(): void {
    this.findStartAndEndWaypoint();
    this.filterControlPoints();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isXxlScreen = window.innerWidth >= 1400;
  }

  findStartAndEndWaypoint(): void {
    if (this.waypointList && this.waypointList.length > 0) {
      for (let waypoint of this.waypointList) {
        if (waypoint.waypointTypeId === WaypointType.START_WAYPOINT) {
          this.startWaypoint = waypoint;
          if (this.startWaypoint.latitude) {
            this.lat = this.startWaypoint.latitude;
          }
          if (this.startWaypoint.longitude) {
            this.lng = this.startWaypoint.longitude;
          }
        } else if (waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT) {
          this.finishWaypoint = waypoint;
        }
      }
    }
  }

  filterControlPoints(): void {
    if ((this.waypointList.length ?? 0) > 0) {
      this.controlPointsList = this.waypointList.filter((item: Waypoint): boolean => item.waypointTypeId === WaypointType.CONTROL_WAYPOINT);
    }
  }

  onClose() {
    this.activeModal.close();
  }

  protected readonly ScoringForType = ScoringForType;
}
